import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import Dashboard from "./pages/Dashboard";
// Settings page import removed (unused)
import Farmers from "./pages/Farmers";
import Consultants from "./pages/Consultants";
import Consultant from "./pages/Consultant";
import Suppliers from "./pages/Suppliers";
import Supplier from "./pages/Supplier";
import OrderDetails from "./pages/OrderDetails";
import Feedbacks from "./pages/Feedbacks";
import Farmer from "./pages/Farmer";
import Others from "./pages/Others";
import Notifications from "./pages/Notifications";
import InputsRequired from "./pages/InputsRequired";
import Login from "./pages/auth-forms/Login";
import "./constants/variables.css";
import "./index.css";
import PrivateRoute from "./auth-routes/PrivateRoute";
import PublicRoute from "./auth-routes/PublicRoutes";
import Admins from "./pages/Admin";
import Managers from "./pages/Managers";
import Manager from "./pages/Manager";
import ManageCrops from "./pages/ManageCrops";
import SuperAdminDashboard from "./pages/SuperAdminDashboard";
import ProfileSetting from "./pages/profileSetting/ProfileSetting";
import Cookies from "js-cookie";

// getDecodedToken removed (unused)
import { useSelector } from "react-redux";
import AdminUser from "./pages/AdminUser";
import ForgotPassword from "./pages/auth-forms/ForgotPassword";
import VerifyOTP from "./pages/auth-forms/VerifyOTP";
import UpdatePassword from "./pages/auth-forms/UpdatePassword";
import ManageRegions from "./pages/ManageRegions";
import ManageSchedualers from "./pages/ManageSchedualers";

function App() {
  const { user } = useSelector((state) => state.user);
  const role = user?.role;
  const isAuthenticated = !!Cookies.get("auth-token"); // Check if token exists

  // const role = useSelector((state) => state.user.role);

  //alert(role);
  // useEffect(() => {
  //   const decodedToken = getDecodedToken();
  //   if (decodedToken) {
  //     setRole(decodedToken.role); // Assuming the role is in the token
  //   }
  // }, []);

  // if (!role) {
  //   return <div>Loading...</div>; // You can return a loading state until the role is determined
  // }
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
       <Route
  path="/verify-otp/:email"
  element={
    <PublicRoute>
      <VerifyOTP />
    </PublicRoute>
  }
/>

<Route path="/update-password/:email" element={ <PublicRoute><UpdatePassword /> </PublicRoute>} />

        
        <Route
          path="*"
          element={
            isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/" />
          }
        />
        {/* Protected Routes wrapped with AuthRoute */}
        <Route
          element={
            <PrivateRoute>
              <MainLayout />
            </PrivateRoute>
          }
        >
          {/* {role === "superadmin" ? ( */}
          {/* {userrole === "admin"?  */}
          {/* <Route path="/admin-dashboard" element={<SuperAdminDashboard />} /> */}

          {(role === "admin" || role === "manager") && <Route path="/dashboard" element={<Dashboard />} />}

          {role === "superadmin" && (
            <>
              <Route path="/dashboard" element={<SuperAdminDashboard />} />
              <Route path="/admins" element={<Admins />} />
              <Route path="/managers" element={<Managers />} />
              <Route path="/manager/:id" element={<Manager />} />
              <Route path="/adminuser/:id" element={<AdminUser />} />

              <Route path="/manage-crops" element={<ManageCrops />} />
               <Route path="/manage-regions" element={<ManageRegions />} />
               <Route path="/manage-schedualers" element={<ManageSchedualers />} />
              <Route path="/inputs-required" element={<InputsRequired />} />
            </>
          )}

          {(role === "admin" || role === "superadmin" || role === "manager") && (
            <>
              <Route path="/farmers" element={<Farmers />} />
              <Route path="/consultants" element={<Consultants />} />
              <Route path="/consultant/:id" element={<Consultant />} />
              <Route path="/suppliers" element={<Suppliers />} />
              <Route path="/supplier/:id" element={<Supplier />} />
              <Route path="/farmer/:id" element={<Farmer />} />
              <Route path="/others" element={<Others />} />
              <Route path="/order-details/:id" element={<OrderDetails />} />
              <Route path="/feedbacks/:id" element={<Feedbacks />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/settings" element={<ProfileSetting />} />
              
            </>
          )}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
